const queryCache = new Map();
const inFlightQueries = new Map();

export const getCachedQuery = async (key, fetcher, { force = false, maxAge = 5 * 60 * 1000 } = {}) => {
  const cached = queryCache.get(key);
  if (!force && cached && Date.now() - cached.cachedAt < maxAge) return cached.value;
  if (!force && inFlightQueries.has(key)) return inFlightQueries.get(key);

  const request = Promise.resolve()
    .then(fetcher)
    .then((value) => {
      queryCache.set(key, { value, cachedAt: Date.now() });
      return value;
    })
    .finally(() => inFlightQueries.delete(key));

  inFlightQueries.set(key, request);
  return request;
};

export const peekCachedQuery = (key, maxAge = 5 * 60 * 1000) => {
  const cached = queryCache.get(key);
  return cached && Date.now() - cached.cachedAt < maxAge ? cached.value : null;
};

export const invalidateCachedQueries = (prefix) => {
  for (const key of queryCache.keys()) {
    if (!prefix || key.startsWith(prefix)) queryCache.delete(key);
  }
};
